module.exports = __webpack_public_path__ + "static/media/knowledge_icon.cc1983a7.png";